import callApi from 'helpers/callApi';

export const getPointList = (params) => callApi({ url: '/points', query: params });
export const getAllPoints = (params) => callApi({ url: '/points', query: { ...params, limit: 10000, page: 1 } });
